import type { RefObject } from 'react';
import { useEffect, useRef, useState } from 'react';

export function useMounted(): RefObject<boolean> {
    const isMounted = useRef<boolean>(false);

    // this little state exists *only* to force one re-render
    const [, setDidMount] = useState(false);

    useEffect(() => {
        isMounted.current = true;
        setDidMount(true); // ← trigger a re-render exactly once
        return () => {
            isMounted.current = false;
        };
    }, []);

    return isMounted;
}
